export class BaseModel {
  public id: number | null = null;
  public active = true;
}
